var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"pv-image-dialog",attrs:{"visible":_vm.data.visible,"title":_vm.title,"width":"620px","center":""},on:{"update:visible":function($event){_vm.$set(_vm.data, "visible", $event)}}},[_c('div',[_c('div',{staticClass:"pv-content"},[_c('img',{attrs:{"src":_vm.data.src}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1116bd05","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreviewImageDialog.vue
// module id = null
// module chunks = 